import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Box, Button, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DisplayDate from "../../components/DisplayDate";
import PaperComponent from "../../components/UI/PaperComponent";
import { IAuthorization } from "../../models/authorizations";
import AuthorizationExecutionStatus, {
  APPROVED_SITUATIONS,
  DENIED_SITUATIONS,
} from "./AuthorizationExecutionStatus";
import AuthorizationProvider from "./AuthorizationProvider";

const translationPath = "page.authorizations.";

const AuthorizationsCard = ({
  auth,
  initialDate,
  endDate,
}: {
  auth: IAuthorization;
  initialDate: string;
  endDate: string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const situation = (auth.documentTypeCurrentSituation || "")
    .trim()
    .toLowerCase();
  const statusColor = APPROVED_SITUATIONS.includes(situation)
    ? "#28bd45"
    : DENIED_SITUATIONS.includes(situation)
    ? "#d80202"
    : situation === "em analise" || situation === "em análise"
    ? "#b1b1b1"
    : "";

  return (
    <PaperComponent sx={{ minWidth: 300, maxWidth: 800 }}>
      <Grid container>
        <Grid
          item
          xs={12}
          display={"flex"}
          flexWrap={"wrap"}
          columnGap={4}
          rowGap={1}
          px={2}
          pt={2}
        >
          <Box>
            <Typography variant="caption" fontWeight={"bold"} display={"block"}>
              {t(translationPath + "authorization_status")}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: statusColor, fontWeight: "bold" }}
            >
              {auth.documentTypeCurrentSituation}
            </Typography>
          </Box>
          <Box>
            <Typography variant="caption" fontWeight={"bold"} display={"block"}>
              {t(translationPath + "execution_stage")}
            </Typography>
            <AuthorizationExecutionStatus auth={auth} />
          </Box>
        </Grid>
        <Grid item container xs={8} sm={10} px={2} pb={2} pt={1}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" fontWeight={"bold"} fontSize={18}>
              {auth.authorizationIntegrationId}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} display={"flex"} alignItems={"center"}>
            <DisplayDate typography={{ variant: "subtitle1" }}>
              {dayjs(auth.requestDate)}
            </DisplayDate>
          </Grid>
          {auth.beneficiaryName && (
            <AuthorizationProvider
              name={auth.beneficiaryName}
              label="beneficiary"
            />
          )}
          {auth.cardCode && (
            <AuthorizationProvider name={auth.cardCode} label="card_code" />
          )}
          {auth.providerRequesterName && (
            <AuthorizationProvider
              name={auth.providerRequesterName}
              label="provider"
            />
          )}
          {auth.doctorRequesterName && (
            <AuthorizationProvider
              name={auth.doctorRequesterName}
              label="doctor"
            />
          )}
          {auth.providerExecutorName && (
            <AuthorizationProvider
              name={auth.providerExecutorName}
              label="provider"
            />
          )}
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          display={"flex"}
          flexDirection={"column"}
          gap={1}
          py={2}
        >
          <Button
            variant="text"
            size="small"
            startIcon={<AddRoundedIcon />}
            sx={{ mr: 2 }}
            onClick={() =>
              navigate(
                `${initialDate}/${endDate}/${auth.authorizationIntegrationId}`
              )
            }
          >
            {t(translationPath + "see_more")}
          </Button>
        </Grid>
      </Grid>
    </PaperComponent>
  );
};

export default AuthorizationsCard;
